import type { IFormSelectInputOption } from '@modules/forms/types';
import { useI18n } from '@modules/i18n/composables';

export interface GroupBySelectOptionsComposable {
  buildList(list: (string | number)[] | undefined, translationKey: symbol, shortCode: string, translateValues?: boolean): IFormSelectInputOption<string>[];
}

export default function useGroupBySelectOptions(): GroupBySelectOptionsComposable {
  const { getTranslation } = useI18n();

  function buildList(
    list: (string | number)[] | undefined,
    translationKey: symbol,
    shortCode: string,
    translateValues?: boolean,
  ): IFormSelectInputOption<string>[] {
    return list?.map((val) => (
      {
        value: String(val),
        label: getTranslation(translationKey, shortCode.replace(/%s/g, String(val)), translateValues ? { item: val } : undefined).value,
      }
    )) ?? [];
  }

  return {
    buildList,
  };
}
